'use client';

import React from 'react';
import { Toaster } from 'sonner';

export default function ToastProvider() {
  return (
    <Toaster
      position="bottom-right"
      toastOptions={{
        duration: 3500,
        style: {
          fontFamily: 'var(--font-plus-jakarta-sans)',
          fontSize: '14px',
          fontWeight: '500',
        },
      }}
    />
  );
}